import { AlertOctagonIcon, EyeIcon, InfoIcon } from "lucide-react";
import { NotificationType, TNotification } from "../../types/Notifications";
import dayjs from "dayjs";
import { CONFIG } from "../../constants/config";

export const DetailPageNotification = ({
  notification,
  onClick,
}: {
  notification: TNotification;
  onClick: () => void;
}) => {
  return (
    <div className="pt-2">
      <div className="flex mb-3">
        <div className="mr-3 pt-1">
          {notification.type === NotificationType.ERROR ? (
            <AlertOctagonIcon
              className={`h-5 w-5 ${
                notification.isRead ? "text-gray-600" : "text-red-700"
              }`}
            />
          ) : (
            <InfoIcon
              className={`h-5 w-5 ${
                notification.isRead ? "text-gray-600" : "text-blue-500"
              }`}
            />
          )}
        </div>
        <div>
          <div className="mb-2 text-gray-900 font-bold ">
            {notification.message}
          </div>
          <div className="text-sm mb-3 text-gray-900">
            {notification.details}
          </div>
          <div className="text-xs font-semibold text-gray-700">
            <span className="mr-3">
              {/* Sent:{" "} */}
              {dayjs(notification.updated_at).format(
                CONFIG.STANDARD_DATETIME_FORMAT
              )}
            </span>
          </div>
          {/* <div className="mb-3 text-xs text-gray-400">
            <span className="mr-3">
              Created:{" "}
              {dayjs(notification.created_at).format(
                CONFIG.STANDARD_DATETIME_FORMAT
              )}
            </span>
          </div> */}

          {/* <div
            className="text-blue-700 flex gap-3 cursor-pointer"
            onClick={onClick}
          >
            <EyeIcon />
            <span className="underline">View</span>
          </div> */}
        </div>
      </div>
    </div>
  );
};
